<template>
  <v-dialog
    content-class="video-dialog"
    v-model="data.isOpen"
    max-width="750"
    @click:outside="handleClose"
  >
    <v-card class="video-dialog__card">
      <div class="video-dialog__header">
        <v-btn icon @click="handleClose" color="white" large>
          <v-icon size="30px">mdi-close</v-icon>
        </v-btn>
      </div>
      <iframe
        width="100%"
        height="410px"
        :src="data.videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe
    ></v-card>
  </v-dialog>
</template>

<script>
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "VideoDialog",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$gtm.trackCustomEvent({
      event: GTM_EVENT_NAME.HELP_VIDEO_SHOW,
      video_url: this.data.videoUrl
    });
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .video-dialog {
  border-radius: 25px;
  &__card {
    background: black;
    padding: 0 $spacing * 3 $spacing * 3 $spacing * 3;
    iframe {
      border-radius: 0 !important;
    }
  }

  &__header {
    padding: $spacing * 2.5 0 $spacing 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
